import Loadable from 'components/core/Loadable';
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
const Page404Page = Loadable(lazy(() => import('pages/404Page/index')));
const HomePage = Loadable(lazy(() => import('pages/HomePage/index')));


const Fallback: RouteObject = {
  path: '*',
  element: <Outlet />,
  children: [
    { index: true, element: <HomePage /> },
    { path: '*', element: <Page404Page /> },
  ],
};

export default Fallback;
